module.exports = "/_next/static/images/8c7c2662b0f4efd99c7114038f975658-piecito-mobile-no.png.webp";